import React, { Component } from 'react';

import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';
import InputField from '../../../../components/inputs/inputField';

class AddFolderModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            folder: props.folder,
            uploading: false,
            folderName: '',
            folderNameErrorTrigger: false
        };
    }


    addFolder = async () => {
        const { orgId, eventId } = this.props;
        const { files, folderName } = this.state;


        if (folderName) {
            this.setState({ folderNameErrorTrigger: false, uploading: true });
            let payload = { folderName };
            if (this.props.parentFolder) {
                payload.parentFolder = this.props.parentFolder;
            }

            await API().post(`/Organizations/${orgId}/events/${eventId}/assetsfolder`, payload)
                .then((response) => {
                    let assetsFolder = response.data;
                    if (assetsFolder) {
                        assetsFolder.isFolder = true;
                        assetsFolder.documentCount = 0;
                        this.props.addFolder(assetsFolder, () => {
                            this.props.toggle();

                        });
                    }
                })
                .catch((error) => {
                    console.log('error', error);

                }
                );



        } else {
            this.setState({ folderNameErrorTrigger: true });
        }

    };

    removeFile = (file) => {
        const filteredFiles = this.state.files.filter((f) => f.name !== file.name);
        this.setState({ files: filteredFiles });
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { files, uploading, folderName, folderNameErrorTrigger } = this.state;
        return (
            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Add Folder"}
                    bodyHeaderText={'Create a folder to store files'}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Name"
                                    value={folderName}
                                    required={true}
                                    errorTrigger={folderNameErrorTrigger}
                                    onChange={(e) => {
                                        this.setState({ folderName: e.target.value });
                                    }}
                                />
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!uploading ? 'Create' : 'Creating...'}
                    actionButton={() => this.addFolder()}
                    actionButtonDisabled={uploading}


                ></FieldModal>

            </div>

        );
    }
}

export default AddFolderModal;
